export const GOVERNANCE_ALLOWED_ACTIONS = Object.freeze({
  EDIT_CAMPAIGN_SETUP: "edit_campaign_setup",
});

export const BUILDER_STEP_LABELS = Object.freeze({
  program: "Program and goal",
  cohort: "Audience",
  channels: "Channels and messages",
  review: "Review and governance",
});

const GOVERNANCE_ISSUE_FALLBACKS = Object.freeze({
  quality_gate: {
    owner: "Analytics operations",
    resolution: "Review suppression reasons and source-data quality for this evidence period.",
    affectedBuilderStep: "program",
  },
  latest_run: {
    owner: "Campaign owner",
    resolution: "Select the latest available evidence period.",
    affectedBuilderStep: "program",
  },
  min_cohort: {
    owner: "Campaign owner",
    resolution: "Broaden the aggregate cohort until it meets the privacy minimum.",
    affectedBuilderStep: "cohort",
  },
  guardrail_exclusion: {
    owner: "Analytics operations",
    resolution: "Confirm clinical guardrails are excluded before outreach.",
    affectedBuilderStep: "cohort",
  },
  enrollment_alignment: {
    owner: "Campaign owner",
    resolution: "Align the audience definition with the campaign goal.",
    affectedBuilderStep: "cohort",
  },
  template_coverage: {
    owner: "Campaign owner",
    resolution: "Choose active Workday app templates that cover every planned touch and audience stage.",
    affectedBuilderStep: "channels",
  },
  message_content: {
    owner: "Campaign owner",
    resolution: "Complete the required subject and message content for every touch.",
    affectedBuilderStep: "channels",
  },
  sensitivity_channel: {
    owner: "Campaign owner",
    resolution: "Use Workday app messaging permitted for this audience sensitivity.",
    affectedBuilderStep: "channels",
  },
  cadence_caps: {
    owner: "Campaign owner",
    resolution: "Adjust timing or priority to resolve campaign overlap.",
    affectedBuilderStep: "channels",
  },
  safety_disclaimer: {
    owner: "Campaign owner",
    resolution: "Add the approved safety disclaimer to each applicable message.",
    affectedBuilderStep: "channels",
  },
});

const DEFAULT_ISSUE = Object.freeze({
  owner: "Campaign owner",
  resolution: "Review this check and update the affected campaign setup.",
  affectedBuilderStep: "review",
});

export function governanceIssueFor(check) {
  const fallback = GOVERNANCE_ISSUE_FALLBACKS[check?.id] || DEFAULT_ISSUE;
  const requestedStep = check?.affectedBuilderStep || check?.remediation?.affectedBuilderStep;
  const affectedBuilderStep = BUILDER_STEP_LABELS[requestedStep]
    ? requestedStep
    : fallback.affectedBuilderStep;
  return {
    owner: check?.owner || check?.remediation?.owner || fallback.owner,
    resolution: check?.resolution || check?.remediation?.resolution || fallback.resolution,
    affectedBuilderStep,
    affectedBuilderStepLabel: BUILDER_STEP_LABELS[affectedBuilderStep],
    allowedAction:
      check?.allowedAction ||
      check?.remediation?.allowedAction ||
      GOVERNANCE_ALLOWED_ACTIONS.EDIT_CAMPAIGN_SETUP,
  };
}
